import styled from "styled-components";

export const HeaderCont = styled.div`
  height: 256px;
  background-image: url("https://gos3.ibcdn.com/gi-orange-bg-2-1694174727.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;
  width: 100%;
`;
export const HeaderContInner = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding-top: 3rem;
  .subHeading {
    display: flex;
    justify-content: space-between;
  }
  .subHeading__left {
    width: 790px;
    flex-shrink: 0;
    font-family: 'Rubik';
    color: ${(p) => (p.theme ? p.theme.colors.goWhite.base : "#fff")};

    .stops-details {
      font-size: 1.8rem;
      line-height: 1.8rem;
      margin-bottom: 1rem;
      text-shadow: 1px 1px 2px #00000040;
    }
    
    .booking-details {
      font-size: 1.8rem;
      line-height: 1.8rem;
      display: flex;
      text-shadow: 1px 1px 2px #00000040;
    }

    .subText {
      padding-right: 1rem;
      margin-right: 1rem;
      border-right: 0.1rem #fff solid;
      font-weight: 600;
    }

    .hrSubText {
      padding-right: 1rem;
      margin-right: 1rem;
      font-weight: 600;
      font-size: 1.8rem;
      line-height: 1.8rem;
    }

    .endDate {
      border-left: 0.1rem #fff solid;
      padding-left: 1rem;
      margin-left: 1rem;
    }

    .fontSemiBold {
      font-weight: 600;
    }
  }

  .subHeading__right {
    width: 390px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    .infoText {
      font-family: 'Rubik';
      font-size: 1.6rem;
      font-weight: 600;
      color: ${(p) => (p.theme ? p.theme.colors.goWhite.base : "#fff")};
      text-shadow: 1px 1px 2px #00000040;
    }
  }
`;
